module.exports = __webpack_public_path__ + "img/icon-letter-p.996b6441.svg";